module.exports = __webpack_public_path__ + "img/home_3.a19e53ee.png";